<app-larged-tuile
  icon="fa-kit fa-picto-filtration"
  [title]="'dashboard.filtration' | translate"
  [buttons]="getButtons()"
  [status]="getStatus() | translate"
  [mode]="
    this.actionStack!.getValue('pvCModeFonctionnement') === 1
      ? (P00058ProgrammeFiltrationManuel[
          this.actionStack!.getValue('pvCProgrammeManuel')
        ].value | translate)
      : this.actionStack!.getValue('pvCModeFonctionnement') === 2
        ? (P00058ProgrammeFiltrationAuto[
            this.actionStack!.getValue('pvCProgrammeAuto')
          ].value | translate)
        : ''
  "
  [statusMode]="
    this.actionStack!.getValue('pvSAlarme') === 1
      ? 'alarm'
      : getButtons()[this.actionStack!.getValue('pvCModeFonctionnement')]
          .status!
  "
  [selectItem]="this.actionStack!.getValue('pvCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Controle,
      'pvCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
